import React, { ChangeEvent, CSSProperties, memo, useMemo } from 'react';
import { Input } from 'antd';
import { NumericFormat } from 'react-number-format';
import { NumberFormatValues } from 'react-number-format/types/types';

interface Props extends React.PropsWithChildren<any> {
  value?: number | null;
  currency?: string | null;
  locale?: string | null;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  isAllowed?: (values: NumberFormatValues) => boolean;
  style?: CSSProperties;
}

const defaultMaskOptions = {
  prefix: '$',
  thousandSeparator: ',',
  decimalSeparator: '.',
  decimalScale: 2,
};

const CurrencyInput = memo<Props>(({ value = 0, currency = 'USD', locale = 'en-US', ...props }) => {
  const getCurrencyOptions = useMemo(() => {
    try {
      const numberFormat = new Intl.NumberFormat(locale || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const parts = numberFormat.formatToParts(value || 10000);
      let prefix = defaultMaskOptions.prefix;
      if (parts[0].type === 'currency') {
        prefix = `${parts[0].value} `;
      }

      return {
        prefix,
      };
    } catch (error) {
      if (currency) {
        return {
          ...defaultMaskOptions,
          prefix: `${currency} `,
        };
      } else {
        return defaultMaskOptions;
      }
    }
  }, [currency, locale, value]);

  return (
    <NumericFormat
      inputMode="numeric"
      {...defaultMaskOptions}
      value={value}
      {...getCurrencyOptions}
      customInput={Input}
      {...props}
    />
  );
});

export default CurrencyInput;
